<script setup lang="ts">
import { formatNumberFullTruncate } from '../helpers/utils'
import { twMerge } from 'tailwind-merge'
import { computed } from 'vue'
import { isInStarReset } from '@/composables/game/player'
import { usePlayer } from '@/composables/game/player'
import { useTooltipSuppressor } from '@/composables/helpers/tooltip-suppressor'

const props = defineProps<{
	image: string
	currentValue: number
	label: string
	isNew?: boolean
	cardClass?: string
	imageClass?: string
	wrapperClass?: string
	labelClass?: string
}>()
const { canUseMines } = usePlayer()
const { suppressed } = useTooltipSuppressor()

const tooltipContent = computed(() => {
  if (props.label === 'Stars' && isInStarReset.value) {
    return 'Stars converted from your Season 1 USDT balance will expire on February 11 at 10:00 AM UTC.'
  }
  if (props.label === 'Mines') {
    return canUseMines.value ? props.label : 'You need level 5 onwards to use mines.'
  }
  return props.label
})
</script>

<template>
  <VTooltip
    style="padding: 0 !important;"
    :disabled="!tooltipContent || suppressed"
    placement="right"
    :triggers="['touch', 'click', 'hover']"
    :popper-triggers="['touch', 'click', 'hover']"
    :distance="4"
    popper-class="achievement-card-tooltip"
    auto-hide
  >
    <template
      #popper
    >
      <span v-html="tooltipContent" />
    </template>
    <div
      :class="twMerge('h-[110px] rounded-xl p-0.5 flex flex-col items-center justify-center relative', cardClass, currentValue === 0 ? 'opacity-[0.44]' : '')"
    >
      <div
        v-if="isNew"
        class="absolute -top-[6px] h-5 left-1/2 -translate-x-1/2 rounded-[6px] bg-card-completed flex items-center justify-center text-xs font-semibold -tracking-[0.24px] text-black uppercase px-2"
      >
        NEW
      </div>
      <div
        :class="twMerge('flex-1 w-full h-full bg-dark-top-layer rounded-[11px] flex flex-col items-center justify-center p-[7px] gap-y-1', wrapperClass)"
      >
        <img
          :class="twMerge('w-auto h-[64px] max-w-full object-cover my-0.5', imageClass)"
          :src="image"
        >
        <div
          :class="twMerge('whitespace-nowrap text-base font-semibold -tracking-[0.32px] text-white/[.87]', labelClass)"
        >
          {{ formatNumberFullTruncate(currentValue) }}
        </div>
      </div>
    </div>
  </VTooltip>
</template>

<style scoped lang="scss">
.bg-card-completed {
	background: linear-gradient(90deg, #FFF246 0%, #E5B80B 37%, #FFF571 68.5%, #E5B80B 100%);
}

.bg-card-incompleted {
	background: linear-gradient(90deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.65) 100%);
}
</style>
<style lang="scss">
.text-linear-gold {
	background: var(--gold, linear-gradient(90deg, #FFF246 0%, #E5B80B 37%, #FFF571 68.5%, #E5B80B 100%));
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	display: inline-block;
}
</style>
<style lang="scss">
.achievement-card-tooltip {
	&.v-popper--theme-tooltip {

		.v-popper__inner {
			@apply text-left whitespace-pre bg-dark-top-most-layer rounded-[4px] px-3 py-2 text-sm font-bold max-w-[168px] #{!important};
		}

		.v-popper__arrow-outer {
			@apply border-dark-top-most-layer #{!important}
		}

		.v-popper__arrow-inner {
			@apply border-dark-top-most-layer #{!important}
		}
	}
}
</style>